import React from 'react';
import { Container, Paper, Typography } from '@mui/material';

const LeaveRequests = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography variant="h5" component="h2" gutterBottom>
          Demandes de Congés
        </Typography>
        <Typography variant="body1" color="textSecondary">
          Cette fonctionnalité est temporairement indisponible pour maintenance.
          Nous travaillons à son amélioration pour mieux répondre à vos besoins.
        </Typography>
      </Paper>
    </Container>
  );
};

export default LeaveRequests;
